import { useState } from "react";
import { CornerDownLeftIcon } from "lucide-react";

import { Icon } from "@/components/atoms/Icon";
import { Select } from "@/components/molecules/Select";
import { type TableDialogSelectionActionsProps } from "@/components/organisms/Table/TableDialog";
import { icons } from "@/objects/@icons";
import { Button } from "@/components/ui/button";
import { ButtonGroup } from "@/components/ui/button-group";

export type DataViewThreadMenuOption = {
  id: string;
  message: string;
};

type DataViewThreadActionsProps = TableDialogSelectionActionsProps & {
  onPrepareThread: (checkedRowIds: string[], draft?: string) => void;
  menuOptions: readonly DataViewThreadMenuOption[];
};

export function DataViewThreadActions({
  checkedRowIds,
  clearSelection,
  onPrepareThread,
  menuOptions,
}: DataViewThreadActionsProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  const run = (draft?: string) => {
    onPrepareThread(checkedRowIds, draft);
    clearSelection();
    setMenuOpen(false);
  };

  return (
    <Select<DataViewThreadMenuOption>
      value={null}
      onChange={(item) => run(item.message)}
      data={[...menuOptions]}
      getOptionKey={(item) => item.id}
      size="md"
      placement="top-end"
      popperMinWidth="280px"
      open={menuOpen}
      onOpenChange={setMenuOpen}
      popperClickable={false}
      anchor={
        <ButtonGroup>
          <Button variant="outline" onClick={() => run()}>
            Thread
            <CornerDownLeftIcon size={16} />
          </Button>
          <Button
            variant="outline"
            size="icon"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <Icon ReactIcon={icons.chevronDown} size="sm" />
          </Button>
        </ButtonGroup>
      }
    >
      <Select.Options<DataViewThreadMenuOption>>
        {(item) => <Select.Option value={item}>{item.message}</Select.Option>}
      </Select.Options>
    </Select>
  );
}
